// https://stackblitz.com/edit/angular-mfsxfi?file=src%2Fapp%2Faddons.wrapper.ts

import { Component, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FieldWrapper, FormlyFieldConfig } from '@ngx-formly/core';
@Component({
  selector: 'formly-wrapper-addons',
  template: `
    @if (to.readOnly) {
      @if (tmpl === '') {
        <div class="read-only-field">
          <div class="label">{{ to.label }}:</div>
          <div class="flex-1 d-flex justify-start items-end" [innerHtml]="value || '--'"></div>
        </div>
      }
      @if (tmpl !== '') {
        <div class="read-only-field" [innerHtml]="tmpl"></div>
      }
    }
    <div [style.display]="to.readOnly ? 'none' : ''">
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
  styles: [
    `
      .read-only-field {
        padding: 1em;
        padding-right: 2em;
        display: flex;
        flex-direction: row;
      }
      .read-only-field > * {
        word-break: break-word;
      }
      .read-only-field > .label {
        font-weight: bold;
        margin-right: 10px;
        flex: 0 0 170px;
        max-width: 170px;
      }
      @media (max-width: 959px) {
        .read-only-field {
          flex-direction: column;
        }
        .read-only-field > .label {
          flex: initial;
          max-width: none;
        }
      }
    `,
  ],
  standalone: false,
})
export class FormlyReadOnlyWrapperComponent extends FieldWrapper implements OnInit {
  private santitizer = inject(DomSanitizer);

  @ViewChild('fieldComponent', { read: ViewContainerRef }) fieldComponent!: ViewContainerRef;

  field: FormlyFieldConfig;

  tmpl = '';

  private valueFormatter: (value: any) => any;

  ngOnInit() {
    if (this.to.valueFormatter) {
      this.valueFormatter = this.to.valueFormatter;
    }
    if (this.to.readOnly && this.to.readOnlyTemplate && this.to.readOnlyTemplate !== '') {
      this.tmpl = this.to.readOnlyTemplate(this.field);
    }
  }

  get value(): string | SafeHtml {
    return this.valueFormatter
      ? this.santitizer.bypassSecurityTrustHtml(this.valueFormatter(this.formControl.value))
      : this.formControl.value;
  }
}
